import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Accordion, Form, Alert, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from '../../../../../../../GlobalComponents/Toast';
import styles from './MicrosoftResellerPrerequisite.module.scss';
import { CheckCircleFill, CheckLg, XCircleFill, XLg } from 'react-bootstrap-icons';
import { CSP_VERIFY_MPNID, CSP_SAVE_MPNID, GET_CSP_MPNID_DATA } from '../../../../../../../Utils/GlobalConstants';
import { api } from '../../../../../../../Utils/API';
import PrerequisiteErrorState from '../../../../../../../Assets/Images/Illustrations/PrerequisiteErrorState.svg';
import loadingGif from "../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import EmptyDataTableFilterSearch from '../../../../../../../Assets/Images/Illustrations/EmptyDataTableFilterSearch.svg'
import { TOAST_ERROR_ICON_COLOR, TOAST_SUCCESS_ICON_COLOR } from '../../../../../../../Utils/ColorsConfiguration';
import { GenericServerError } from '../../../../../../../Utils/StaticMessages/GenericErrorMessages';
import { MPNIdSavedSuccessToast, ServerErrorPLAVerification } from '../../../../../../../Utils/StaticMessages/ToastMessages';
import { mpnIdRegex } from '../../../../../../../Utils/RegExPatterns';

const MicrosoftResellerPrerequisite = ({ Logout }) => {
  const location = useLocation();                                                                                     // get Location
  const [productServiceId, setProductServiceId] = useState(location.state !== null ? location.state.serviceId : "");                       // Get Service ID From Listing Table
  const navigate = useNavigate();                                               // to use navigate function
  const [mpnId, setMpnId] = useState("");                                       // to set the mpn id/Partner Location Account (ID)(new ui label change) entered by the user
  const [verifyMessage, setVerifyMessage] = useState("");                       // to display the verified message on verifictaion
  const [isMpnVerified, setIsMpnVerified] = useState(false);                     // To check mpn id/Partner Location Account (ID)(new ui label change) is verified or not
  const [domainCheckBlockErrors, setDomainCheckBlockErrors] = useState(false);  // to check error while saving and buying subscription
  const [confirmLoadingFlag, setConfirmLoadingFlag] = useState(false);          // Processing after calling api
  const [isMpnSaved, setIsMpnSaved] = useState(false);                          // when mpn id/Partner Location Account (ID)(new ui label change) is saved
  const [isVerificationHold, setIsVerificationHold] = useState(false);          // for processing intermediate button                                  
  const [isAlreadyConfigured, setIsAlreadyConfigured] = useState(null);         // To check whether mpn id/Partner Location Account (ID)(new ui label change) is already configured or not
  const [serverError, setServerError] = useState(false);                        // server error check state in table during api call to load data

  //POR
  const [mpnVerifyMessage, setMpnVerifyMessage] = useState("");                       
  const [plaVerifyMessage, setPlaVerifyMessage] = useState("");                       
  const [mpnHelpMessage, setMpnHelpMessage] = useState("");                      
  const [plaHelpMessage, setPlaHelpMessage] = useState("");                      
  const [isValidMpaStatus, setIsValidMpaStatus] = useState("");                      
  const [isValidPlaId, setIsValidPlaId] = useState("");                      
  const [partnerName, setPartnerName] = useState("");
  const [mpnMessage, setMpnMessage] = useState("");                       
  const [mpnInfoMessage, setMpnInfoMessage] = useState("");                        

  // Use State for Toasts
  const [toastSuccess, setToastSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastError, setToastError] = useState(false);                                // toast message displaying error message 
  
  // Header Authorization for API
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // Function to get details whether mpn id/Partner Location Account (ID)(new ui label change) is already configured or not
  async function GetMPNData() {
    await api.get(GET_CSP_MPNID_DATA, config)
      .then(resp => {
        setIsAlreadyConfigured(resp.data.isAlreadyConfigured);
        setServerError(false);
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
          setServerError(true);
        }
      });
  };

  //post api for mpn id/Partner Location Account (ID)(new ui label change) verification
  async function MPNidVerification(mpnId) {
    setConfirmLoadingFlag(true);
    const configFile = {
      headers: {
        "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    };
    await api.post(`${CSP_VERIFY_MPNID}?plaId=${mpnId}`, null, configFile)
      .then(resp => {
        if (resp.status = 200) {
          { resp.data.isValidPlaId && resp.data.isValidMpaStatus ? setIsMpnVerified(true) : setIsMpnVerified(false) }
          // setVerifyMessage(resp.data.message);

          setPartnerName(resp.data.partnerName);
          setMpnVerifyMessage(resp.data.mpaMessage);
          setPlaVerifyMessage(resp.data.plaMessage);
          setMpnHelpMessage(resp.data.mpaHelpMessage);
          setPlaHelpMessage(resp.data.plaHelpMessage)
          setIsValidMpaStatus(resp.data.isValidMpaStatus);
          setIsValidPlaId(resp.data.isValidPlaId);
          setMpnMessage(resp.data.mpnMessage === null ? "" : resp.data.mpnMessage);                   
          setMpnInfoMessage(resp.data.mpnHelpMessage === null ? "" : resp.data.mpnHelpMessage);
          setConfirmLoadingFlag(false);
          setIsVerificationHold(false);
        }
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        } 
        else if(error?.status == 500 || error?.response?.status == 500){
          setToastMessage(ServerErrorPLAVerification);
          setToastError(true);
          setTimeout(() => {
            setToastError(false);
          }, 5000);
        }
        else {
          setConfirmLoadingFlag(false);
        }
      })
  };

  //post api for saving mpn id/Partner Location Account (ID)(new ui label change)
  async function MPNidSave(mpnId) {
    setConfirmLoadingFlag(true);
    const configFile = {
      headers: {
        "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    };
    await api.post(`${CSP_SAVE_MPNID}?mpnId=${mpnId}&partnerName=${partnerName}`, null, configFile)
      .then(resp => {
        if (resp.status = 200) {
          setIsMpnSaved(true);
          setToastMessage(MPNIdSavedSuccessToast);
          setToastSuccess(true);
          setTimeout(() => {
            setToastSuccess(false);
          }, 5000);
          setConfirmLoadingFlag(false);
        }
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        setConfirmLoadingFlag(false);
        setIsMpnSaved(false);
        setDomainCheckBlockErrors(true);
      })
  };

  // To check whether it is already configured or not and whether user is going through the provisioning screen
  useEffect(() => {
    // console.log("service id:",productServiceId )
    if (productServiceId !== "")
      GetMPNData();
  }, []);

  return (
    <>
      <Toast toastSetUseState={setToastSuccess} toastCheckUseState={toastSuccess} toastType="success" toastIconColor={TOAST_SUCCESS_ICON_COLOR} toastMessage={toastMessage} />
      <Toast toastSetUseState={setToastError} toastCheckUseState={toastError} toastType="danger" toastIconColor={TOAST_ERROR_ICON_COLOR} toastMessage={toastMessage} />
      
      {
        productServiceId === "" &&
        <div className={styles["no-data-cloud-invoice"]}>
          <img src={PrerequisiteErrorState} className="empty-cloud-invoice-table-svg" />
          <h2 className='mb-2 mt-4'>Vendor Requirement for the service is possible through provisioning.</h2>
          <p className='mb-2'> Please proceed to Cloud Provision for managing.</p>
          <Button onClick={() => navigate('/cloud-provision')}>Proceed</Button>
        </div>
      }
      {
        productServiceId !== "" &&
        <>
          {serverError &&
            <div className={styles["no-data-cloud-invoice"]}>
              <img src={EmptyDataTableFilterSearch} className="empty-cloud-creditNote-table-svg" />
              <h2 className="mt-4 mb-3">{GenericServerError}</h2>
            </div>
          }
          {/* when mpn id/Partner Location Account (ID)(new ui label change) already exists */}
          {
            isAlreadyConfigured && !serverError &&
            <div className={styles["no-data-cloud-invoice"]}>
              <img src={PrerequisiteErrorState} className="empty-cloud-invoice-table-svg" />
              <h2 className='mb-2 mt-4'>Vendor Requirement for the selected service is already provisioned</h2>
              <p className='mb-2'> Please proceed to My Profile for managing.</p>
              <Button onClick={() => navigate('/profile')}>Proceed</Button>
            </div>
          }

          {
            isAlreadyConfigured === null && !serverError &&
            <div className={styles["no-data-cloud-invoice"]}>
              <div className="management-console-loading-component text-center"><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading...</p></div>
            </div>
          }

          {/* when mpn id doesn't exist */}
          {!isAlreadyConfigured && isAlreadyConfigured != null && !serverError &&
            <div className="main-content">
              <Container fluid>
                <Row>
                  <Col className="justify-content-between d-flex align-items-center">
                    <div className="cpointer text-large">
                      <span className="back" onClick={() => navigate('/cloud-provision', { state: { serviceId: productServiceId}})}>&nbsp;</span>&nbsp;<strong>Vendor requirements</strong>
                    </div>
                  </Col>
                </Row>
                <div className='service-management-csp-header mt-3 ml-5'>
                  <Row>
                    <Col md={3}>
                      <Form.Group >
                        <Form.Label>Vendor</Form.Label>
                        <NavDropdown title="Microsoft" id="cloud-service-dropdown"
                          className={`servcies-dropdown ${styles['dropdown-disabled']}`} disabled>
                        </NavDropdown>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
                <div className="accordion-panel pb-4">
                  <Accordion
                    defaultActiveKey="0"
                    className="pre-requisite-panels"
                    alwaysOpen>
                    <Accordion.Item className={`mt-5 ${domainCheckBlockErrors ? "accordionErrors" : ""}`} eventKey="0">
                      <Accordion.Header>
                        <h3 className={`${styles['accordion-header-wrapper']}`}>
                          <label>
                            <span className={`${styles['accordion-number']}`}>1</span>
                          </label>
                          <label className="pl-2">
                            <span className={`${styles['accordion-name']}`}>Partner Location Account (PLA) ID</span>
                          </label>
                        </h3>
                      </Accordion.Header>
                      <Accordion.Body className='pt-0'>
                        <div className={`${styles['accordion-content']}`}>
                          <Row>
                            <Col lg={8} md={12}>
                              <Form.Group className="mb-3" >
                                {/* <Form.Label>Enter Partner Location Account (PLA) ID</Form.Label> */}
                                <Form.Label>Partner Name - {partnerName ? partnerName : "NA"}</Form.Label>
                                <Row>
                                  <Col md={6} >
                                    <Form.Control
                                      type="text"
                                      value={mpnId}
                                      placeholder="Enter Partner Location Account (PLA) ID"
                                      disabled={isMpnSaved}
                                      onKeyDown={(e) => {
                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        setIsMpnVerified(false);
                                        setMpnVerifyMessage("");
                                        setPlaVerifyMessage("");
                                        setMpnHelpMessage("");
                                        setPlaHelpMessage("");
                                        setPartnerName("");
                                        setMpnMessage("");
                                        setMpnInfoMessage("");
                                        setDomainCheckBlockErrors(false);
                                        if ( e.target.value === '' || mpnIdRegex.test(e.target.value) && e.target.value.length > 0) {
                                          setMpnId(e.target.value);
                                        }
                                      }}
                                    />
                                   {/* <>
                                        {isMpnVerified === true && <span className='d-flex items-align-center mt-2'>
                                          <span className="status-success mr-1">&nbsp;</span>
                                          <span className="green text-small">
                                            {verifyMessage}
                                          </span> </span>}

                                        {isMpnVerified === false &&
                                          <span className='d-flex items-align-center mt-2'>
                                            <span className="status-error mr-1">&nbsp;</span>
                                            <span className="red text-small">
                                              {verifyMessage}
                                            </span>
                                          </span>}
                                      </>
                                    {isMpnVerified === null &&
                                      <p className='empty-paragraph'></p>
                                    } */}

                                      <>
                                {/* pla status */}

                                {isValidPlaId === true && plaVerifyMessage != "" && <span className='d-flex items-align-center mt-5'>
                                  <span className="status-success mr-1">&nbsp;</span>
                                  <span className="green text-medium">
                                    {plaVerifyMessage}
                                  </span> </span>}

                                {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                                {mpnMessage=== "" && isValidPlaId === false && plaVerifyMessage != "" &&
                                  <Row>
                                    <Col md={10}>
                                      <span className='d-flex items-align-center mt-5'>
                                        <span className="status-error mr-1">&nbsp;</span>
                                        <span className="red text-medium">
                                          {plaVerifyMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                        </span>
                                      </span>
                                    </Col>
                                    <Col md={2} className='text-right'>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={<Tooltip className='tooltip-upgrade-destination'>
                                          {plaHelpMessage}
                                        </Tooltip>}
                                      >
                                        <span className="infoIcon-vendor-requirement mt-3"></span>
                                      </OverlayTrigger>
                                    </Col>
                                  </Row>}
                              </>

                              <>
                                {/* mpn status */}
                                {isValidMpaStatus === true &&  mpnVerifyMessage != "" && <span className='d-flex items-align-center mt-3'>
                                  <span className="status-success mr-1">&nbsp;</span>
                                  <span className="green text-medium">
                                    {mpnVerifyMessage}
                                  </span> </span>}

                                {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                                {mpnMessage=== "" && isValidMpaStatus === false && mpnVerifyMessage != "" &&
                                  <Row>
                                    <Col md={10}>
                                      <span className='d-flex items-align-center mt-3'>
                                        <span className="status-error mr-1">&nbsp;</span>
                                        <span className="red text-medium">
                                          {mpnVerifyMessage}
                                        </span>
                                      </span>
                                    </Col>
                                    <Col md={2} className='text-right'>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={<Tooltip className='tooltip-upgrade-destination'>
                                          {mpnHelpMessage}
                                        </Tooltip>}
                                      >
                                        <span className="infoIcon-vendor-requirement mb-1 mt-2"></span>
                                      </OverlayTrigger>
                                    </Col>
                                  </Row>}
                                  {mpnMessage!== "" &&
                                    <Row>
                                      <Col md={10}>
                                        <span className='d-flex items-align-center mt-5'>
                                          <span className="status-error mr-1">&nbsp;</span>
                                          <span className="red text-medium">
                                            {mpnMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                          </span>
                                        </span>
                                      </Col>
                                      <Col md={2} className='text-right'>
                                        <OverlayTrigger
                                          placement="right"
                                          overlay={<Tooltip className='tooltip-upgrade-destination'>
                                            {mpnInfoMessage}
                                          </Tooltip>}
                                        >
                                          <span className="infoIcon-vendor-requirement mt-3"></span>
                                        </OverlayTrigger>
                                      </Col>
                                    </Row>}
                                  </>
                              {isValidMpaStatus === null &&
                                <p className='empty-paragraph'></p>
                              }
                              {isValidPlaId === null &&
                                <p className='empty-paragraph'></p>
                              }

                                  </Col>
                                  <Col md={6}>
                                    {mpnId.length > 0  ?
                                      (!confirmLoadingFlag && !isMpnSaved && <Button
                                        className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                        variant="light"
                                        onClick={() => { MPNidVerification(mpnId); setIsVerificationHold(true); }}
                                      >
                                        Verify
                                      </Button>) : (!confirmLoadingFlag && <Button
                                        className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                        variant='light'
                                        disabled
                                      >
                                        Verify
                                      </Button>)}
                                      {
                                        mpnId.length > 0 && isMpnSaved && 
                                        <Button
                                        className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                        variant='light'
                                        disabled
                                      >
                                        Verify
                                      </Button>
                                      }
                                    {confirmLoadingFlag && <Button
                                      disabled
                                      className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                      variant="light"
                                    >
                                      Processing . . .
                                    </Button>}
                                  </Col>
                                </Row>
                                
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="text-right">
                              <div className="button-wrapper">
                                {!confirmLoadingFlag && <>
                                  {mpnId.length === 0 && <Button
                                    className="btn btn-lg mx-2"
                                    variant="light"
                                    disabled
                                  >
                                    Clear
                                  </Button>}
                                  {mpnId.length > 0 && !isMpnSaved &&
                                    <Button
                                      className="btn btn-lg btn-border-light mx-2"
                                      variant="light"
                                      onClick={() => {
                                        setMpnId("");
                                        setVerifyMessage(""); setIsMpnVerified(false); setDomainCheckBlockErrors(false);
                                        setMpnVerifyMessage("");
                                        setPartnerName("");
                                        setPlaVerifyMessage("");
                                        setMpnHelpMessage("");
                                        setPlaHelpMessage("");
                                        setMpnMessage("");
                                        setMpnInfoMessage("");
                                      }}
                                    >
                                      Clear
                                    </Button>}
                                  {
                                    !isMpnVerified && !isMpnSaved &&
                                    <>
                                      <Button
                                        className="btn btn-lg ml-2 px-4"
                                        variant="light"
                                        disabled
                                      >
                                        Save
                                      </Button>
                                    </>
                                  }

                                  {
                                    isMpnVerified && !isMpnSaved &&
                                    <Button
                                      className="btn btn-lg ml-2 px-4"
                                      onClick={() => {
                                        MPNidSave(mpnId);
                                      }}
                                    >
                                      Save
                                    </Button>
                                  }
                                  {/* when mpn id/Partner Location Account (ID)(new ui label change) is saved then navigate to product listing screen*/}
                                  {
                                    isMpnVerified && isMpnSaved &&
                                    <Button
                                      className="btn btn-lg ml-2 px-4"
                                      onClick={() => {
                                        navigate('/cloud-provision');
                                      }}
                                    >
                                      Buy Subscription
                                    </Button>
                                  }
                                </>}
                                {confirmLoadingFlag && !isMpnSaved && !isVerificationHold &&
                                  <><Button
                                    className="btn btn-lg mx-2"
                                    variant="light"
                                    disabled
                                  >
                                    Clear
                                  </Button>
                                    <Button
                                      disabled
                                      className="ml-2 px-4 btn-border-light w-md-auto col-xs-12"
                                      variant="light"
                                    >
                                      Processing . . .
                                    </Button></>
                                }
                                {confirmLoadingFlag && !isMpnSaved && isVerificationHold &&
                                  <><Button
                                    className="btn btn-lg mx-2"
                                    variant="light"
                                    disabled
                                  >
                                    Clear
                                  </Button>
                                    <Button
                                      disabled
                                      className="ml-2 px-4 btn-border-light w-md-auto col-xs-12"
                                      variant="light"
                                    >
                                      Save
                                    </Button></>
                                }
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>{domainCheckBlockErrors &&
                    <span className='d-flex items-align-center mt-2'>
                      <span className="mr-1">&nbsp;</span>
                      <span className="red text-small">
                        We encountered an issue while saving the Partner Location Account (PLA) ID. Please try again!</span>
                    </span>}
                </div>
              </Container >
            </div >}
        </>
      }
    </>
  )
}

export default MicrosoftResellerPrerequisite